import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="mx-auto max-w-4xl px-6 lg:px-10 py-16">
      <div className="overline text-safety">Legal</div>
      <h1 className="mt-2 font-display font-black text-4xl lg:text-5xl tracking-tight text-forest leading-none">
        Terms &amp; Conditions
      </h1>
      <p className="mt-4 text-sm text-muted-foreground">Last updated: 24 August 2026</p>

      <div className="mt-10 space-y-8 text-base leading-relaxed text-foreground/90">
        <section>
          <h2 className="font-display font-bold text-xl text-forest mb-2">1. Who we are</h2>
          <p>
            Furniture Exchange ("the Platform", "we", "us", "our") is a trading name of Corporate
            Office Furniture Ltd, a company registered in England and Wales ("COF Ltd", "the
            Company"). References to "we" or "us" in these Terms mean Corporate Office Furniture
            Ltd trading as Furniture Exchange.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-forest mb-2">2. Acceptance of these Terms</h2>
          <p>
            By accessing or using the Platform, creating an account, posting a listing, or
            purchasing furniture removal services through Furniture Exchange, you agree to be
            bound by these Terms and our Privacy Policy and Cookie Policy. If you do not agree,
            please do not use the Platform. These Terms are governed by the law of England and
            Wales.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-forest mb-2">3. The service</h2>
          <p>
            Furniture Exchange is an online marketplace that connects sellers of surplus office
            furniture (individuals, businesses, and removal companies) with buyers. We do not own,
            inspect, or take title to items listed on the Platform unless expressly stated. We are
            not a party to the contract of sale between buyers and sellers, save for facilitating
            payment processing and, where applicable, verification services.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-forest mb-2">4. Accounts and eligibility</h2>
          <p>
            You must be at least 18 years old and able to form a binding contract under the laws
            of England and Wales to register. You are responsible for maintaining the
            confidentiality of your account credentials and for all activity under your account.
            You must provide accurate, current information when registering and keep it up to
            date.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-forest mb-2">5. Listings, offers and sales</h2>
          <p>
            Sellers are responsible for ensuring listings are accurate and lawful, including
            compliance with the Consumer Rights Act 2015 and, where applicable, the Furniture and
            Furnishings (Fire) (Safety) Regulations 1988. Business sellers dealing with consumers
            must comply with the Consumer Contracts (Information, Cancellation and Additional
            Charges) Regulations 2013, including providing statutory cancellation rights where
            they apply. Buyers should inspect item descriptions carefully; goods are typically sold
            as described in the listing, and, where sold by a trader to a consumer, must be as
            described, fit for purpose and of satisfactory quality under the Consumer Rights Act
            2015.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-forest mb-2">6. Fees and payments</h2>
          <p>
            Any fees, commission or subscription charges applicable to use of the Platform are
            displayed at the point of sale or on our pricing pages before you commit to pay.
            Payments are processed securely by our payment provider, Stripe. We do not store your
            full card details. All prices are shown in GBP (£) and, where applicable, include VAT
            at the applicable UK rate.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-forest mb-2">7. Removal companies</h2>
          <p>
            Removal companies listed on the Platform are independent third parties. We carry out
            reasonable verification checks but do not guarantee the quality, safety or legality of
            any removal service. Any contract for removal services is between you and the removal
            company.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-forest mb-2">8. Prohibited conduct</h2>
          <p>
            You must not use the Platform for unlawful purposes, to post false or misleading
            listings, to infringe intellectual property rights, or to harass other users. We may
            suspend or terminate accounts that breach these Terms.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-forest mb-2">9. Liability</h2>
          <p>
            Nothing in these Terms excludes or limits our liability for death or personal injury
            caused by our negligence, fraud, or any other liability that cannot lawfully be
            excluded or limited under the laws of England and Wales. Subject to that, we are not
            liable for indirect or consequential losses arising from your use of the Platform, or
            for the acts or omissions of other users, sellers or removal companies.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-forest mb-2">10. Marketing from Corporate Office Furniture Ltd</h2>
          <p>
            Furniture Exchange is owned and operated by Corporate Office Furniture Ltd. If you
            consent at registration or another point of collection, we may use your contact
            details to tell you about relevant products and services offered by Corporate Office
            Furniture Ltd, such as office furniture supply. You can withdraw this consent at any
            time — see our Privacy Policy for details.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-forest mb-2">11. Changes to these Terms</h2>
          <p>
            We may update these Terms from time to time to reflect changes in our services or
            legal requirements. Continued use of the Platform after changes take effect
            constitutes acceptance of the revised Terms.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-forest mb-2">12. Governing law and jurisdiction</h2>
          <p>
            These Terms are governed by the laws of England and Wales. Any disputes shall be
            subject to the exclusive jurisdiction of the courts of England and Wales, except
            where mandatory consumer protection rules give you the right to bring proceedings in
            your own local courts.
          </p>
        </section>

        <section>
          <h2 className="font-display font-bold text-xl text-forest mb-2">13. Contact us</h2>
          <p>
            Corporate Office Furniture Ltd, trading as Furniture Exchange. Email:{" "}
            <a href="mailto:info@furnitureexchange.co.uk" className="text-safety hover:underline">
              info@furnitureexchange.co.uk
            </a>
            . See also our{" "}
            <Link to="/privacy" className="text-safety hover:underline">Privacy Policy</Link>{" "}
            and{" "}
            <Link to="/cookies" className="text-safety hover:underline">Cookie Policy</Link>.
          </p>
        </section>
      </div>
    </div>
  );
}
